import { AvailableLineDataRefNode } from '@futrli-sdk/predict';

import { FormulaReferenceOption } from '../../../utils/formulas/types';

/**
 * Takes the given AvailableLineDataRefNode[] tree and converts it to a flat FormulaReferenceOption array.
 * This simpler format is used by the formula editor's mention/reference options.
 * @param options - The available formula options (references)
 * @param depth - current depth of the tree
 * @param output - output array
 */
export const convertFormulaOptionsToMentionData = (
  options: AvailableLineDataRefNode[],
  depth = 1,
  output: FormulaReferenceOption[] = []
) => {
  options.forEach(option => {
    output.push({
      id: option.ref,
      name: option.name,
      depth,
      disabled: option.disabled
    });
    if (option.children.length) {
      convertFormulaOptionsToMentionData(option.children, depth + 1, output);
    }
  });

  return [
    {
      disabled: false,
      id: 'id-non-financial-drivers',
      name: 'Non financial drivers',
      depth: 0
    } as FormulaReferenceOption,
    ...output
  ];
};
